<template>
  <div>
    <a-modal v-model="modalVisible" title="绘制项目地图边界" :width="1366" :centered="true" :bodyStyle="{height: '768px', overflow: 'auto'}">
      <template slot="footer">
        <a-button @click="modalVisible=false">取消</a-button>
        <a-button type="primary" @click="confirm">确认</a-button>
      </template>
      <!--    <span>搜索：</span><input id="tipinput" type="text" style="border: solid 1px #efefef">-->
      <div id="container" @click="" v-if="modalVisible"></div>
      <div id="myPageTop">
        <table style="width: 266px;">
          <tr>
            <td>
              <label>请输入关键字：</label>
            </td>
          </tr>
          <tr>
            <td>
              <a-input id="tipinput" @change="searchPlace()" style="width: 100%;" />
            </td>
          </tr>
        </table>
      </div>
      <div id="panel"></div>
      <div class="input-card" style="width: 250px">
        <h4 style="margin-bottom: 5px; font-weight: 600">双击或右键结束绘制</h4>
        <h5 style="margin-bottom: 5px;">点击多边形可拖拽变为想要的形状</h5>
<!--    <div id="points"></div>-->
        <button class="btn" @click="drawPolygon()">绘制一个新多边形</button>
        <button class="btn" @click="closeEdit()">结束编辑</button>
        <button class="btn" @click="removeThis()">清除当前所选</button>
        <button class="btn" @click="removeAll()">清除所有</button>
      </div>
    </a-modal>
  </div>

</template>
<script>
import {addInterfaceRecord} from "A/xtpz";
import loadAMap from "U/amaploader";
import {mapState} from "vuex";

export default {
  props: ['visible', 'boundarycoordinate', 'centercoordinate'],
  data() {
    return {
      Map: null,
      modalVisible: false,
      map: null,
      coordinate: [],
      marker: null,

      searchStr: '',
      mouseTool: null,
      polygon: null,
      editor: [],
      isDraw: false,
      //用来放新绘所有的多边形
      polygonList:[],
      boundaryCoordinate:null,
      nowModalType:'add',
      mapCenter:[116.397428, 39.90923],
      mapZoom:14,
      //如果已经存在有区域坐标，则存放多个编辑器
      polygonEditorList:[],
      //用来放待编辑的所有的多边形
      toEditPolygonList:[],
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.modalVisible = true;
        this.boundaryCoordinate = this.boundarycoordinate?this.boundarycoordinate:null;
        this.nowModalType = this.modalType;
        this.$nextTick(() => {
          this.init();
        })
      }else{
        this.boundaryCoordinate =null
      }
    },
    modalVisible(val) {
      if (!val) {
        this.$emit('update:visible', false);
      } else {

      }
    },
  },
  mounted(){

  },
  computed:{
    ...mapState({
      userInfo: state => state.userInfo
    }),
  },
  created() {
    this.modalVisible = this.visible;
  },
  methods: {
    addInterfaceRecord(page_name,page_address,interface_name){
      let params={
        page_name:page_name,
        page_address:page_address,
        interface_name:interface_name,
        username:this.userInfo.username,
        useraccount:this.userInfo.useraccount,
      }
      addInterfaceRecord(params)
    },
    async init() {
      var _this = this;
      this.polygonList = []
      this.polygonEditorList = []
      this.toEditPolygonList = []
      this.mapCenter = this.centercoordinate ? JSON.parse(this.centercoordinate) : [116.397428, 39.90923]
      this.mapZoom = this.centercoordinate ? 17 : 14
      var boundarycoordinate = this.boundaryCoordinate ? JSON.parse(this.boundaryCoordinate) : null
      // const AMap = window.AMap
      const AMap = await loadAMap();
      this.addInterfaceRecord("画区域弹窗页面", "components/modals/drawBoundaryCoordinatesModal.vue", "window.AMap")
      var Map = new AMap.Map('container', {
        resizeEnable: true, //是否监控地图容器尺寸变化
        zoom: _this.mapZoom, //初始化地图层级
        center: _this.mapCenter
      });
      this.Map = Map;
      //此处是处理已经存在的边界坐标，可以再次编辑已经设定过的坐标
      if (boundarycoordinate !== null && boundarycoordinate.length > 0) {
        for (let i = 0; i < boundarycoordinate.length; i++) {
          var path = boundarycoordinate[i]
          var polygon = new AMap.Polygon({
            path: path,
            strokeColor: "#FF33FF",
            strokeWeight: 6,
            strokeOpacity: 0.2,
            fillColor: '#1791fc',
            fillOpacity: 0.4,
            strokeStyle: "solid",
          })
          this.Map.add(polygon)
          this.Map.plugin(["AMap.PolyEditor"], function () {
            // 实例化多边形编辑器，传入地图实例和要进行编辑的多边形实例
            var PolygonEditor = new AMap.PolyEditor(_this.Map, polygon);
            polygon.on('click', function (e) {
              // 绘制新图形时关闭编辑
              if (_this.isDraw) return
              _this.mouseTool.close()
              _this.closeEdit()
              //点击之后，直接把这个坐标序列放入到最终结果集中，不管用户最后是否真的编辑了
              _this.polygonList.push(e.target)
              //删掉原先待编辑的多边形序列
              _this.toEditPolygonList = _this.toEditPolygonList.filter(
                  item => item._amap_id !== e.target._amap_id
              )
              // 点击开启编辑
              _this.polygon = e.target
              _this.enablePolyEdit(e)
            })
            _this.polygonEditorList.push(PolygonEditor)
            _this.toEditPolygonList.push(polygon)
          });
        }
      }
      this.mouseTool = new AMap.MouseTool(this.Map)
      AMap.event.addListener(this.mouseTool, 'draw', function (e) {
        _this.isDraw = false
        _this.mouseTool.close()
        _this.polygon = e.obj
        _this.Map.plugin(["AMap.PolyEditor"], function () {
          // 实例化多边形编辑器，传入地图实例和要进行编辑的多边形实例
          _this.polygonList.push(e.obj)
        });
        _this.polygon.on('click', e => {
          // 绘制新图形时关闭编辑
          if (_this.isDraw) return
          _this.mouseTool.close()
          _this.closeEdit()
          // 获取坐标
          //_this.getPoints(e)
          // 点击开启编辑
          _this.polygon = e.target
          _this.enablePolyEdit(e)
        });
      });
    },
    confirm() {
      //准备整理数据，整理为一个JSON对象
      let resultOb = []
      if (this.polygonList.length>0) {
        this.polygonList.forEach(value => {
          this.handelCoordinate(value,resultOb)
        })
      }
      if (this.toEditPolygonList.length>0) {
        this.toEditPolygonList.forEach(value => {
          this.handelCoordinate(value,resultOb)
        })
      }
      if(this.toEditPolygonList.length===0 && this.polygonList.length===0){
        //this.$message.error('请绘制区域坐标，如果要关闭请点击取消');
        this.$confirm('确定不要绘制项目区域坐标吗?',{
          type:'warning',
          centered:true,
        }).then(()=>{
          this.$emit('get-coordinate', '');
          this.modalVisible = false;
        }).catch(()=>{
        });
      }else{
        this.$emit('get-coordinate', JSON.stringify(resultOb));
        this.modalVisible = false;
      }
    },
    handelCoordinate(value,resultOb){
      let points = value.getPath()
      let arr = []
      points.map(v => {
        arr.push([v.lng, v.lat])
      })
      resultOb.push(arr)
    },
    searchPlace() {
      let value = document.querySelector('#tipinput').value
      if (value && value.trim()) {
        var _that = this
        document.querySelector('#panel').style.display = 'block'
        AMap.service(["AMap.PlaceSearch"], function () {
          //构造地点查询类
          var placeSearch = new AMap.PlaceSearch({
            pageIndex: 1, // 页码
            city: "beijing", // 兴趣点城市
            citylimit: false,  //是否强制限制在设置的城市内搜索
            map: _that.Map, // 展现结果的地图实例
            panel: "panel", // 结果列表将在此容器中进行展示
            autoFitView: true, // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
            extensions: 'base' //返回基本地址信息
          });
          //关键字查询
          placeSearch.search(value, function (status, result) {
          });
        });
      } else {
        document.querySelector('#panel').style.display = 'none'
      }
    },
    drawPolygon() {
      this.isDraw = true
      this.closeEdit()
      this.mouseTool.polygon({
        strokeColor: "#FF33FF",
        //strokeOpacity: 1,
        strokeWeight: 6,
        strokeOpacity: 0.2,
        fillColor: '#1791fc',
        fillOpacity: 0.4,
        strokeStyle: "solid"
      })
    },
    enablePolyEdit(e) {
      let _this = this
      setTimeout(() => {
        _this.editor = new AMap.PolyEditor(_this.Map, _this.polygon);
        _this.editor.open();
        _this.isDraw = false
        _this.editor.on('addnode', function (event) {
          //_this.getPoints(e)
        })

        _this.editor.on('adjust', function (event) {
          //_this.getPoints(e)
        })

        _this.editor.on('removenode', function (event) {
          //_this.getPoints(e)
        })
      }, 100)
    },

    getPoints(e) {
      let points = e.target.getPath()
      let arr = []
      points.map(v => {
        arr.push(JSON.stringify([v.lng, v.lat]))
      })
      arr.push(arr[0])
      //document.querySelector('#points').innerText = arr + ','
    },

    clearPoints() {
      //document.querySelector('#points').innerText && (document.querySelector('#points').innerText = '')
    },

    closeEdit() {
      this.editor && this.editor.CLASS_NAME === "AMap.PolyEditor" && this.editor.close();
      this.clearPoints()
    },

    removeThis() {
      //如果这个多边形被删除了，就也删除区域列表中的多边形
      this.polygonList=this.polygonList.filter(
          item => item._amap_id !== this.polygon._amap_id
      )
      this.closeEdit()
      this.Map.remove(this.polygon)
    },
    removeAll() {
      //释放内存
      this.polygonEditorList.forEach(object=>{
        object=null
      })
      this.toEditPolygonList.forEach(object=>{
        this.Map.remove(object)
        object=null
      })
      this.polygonEditorList=[]
      this.toEditPolygonList=[]
      //记得置空
      this.polygonList=[]
      this.closeEdit()
      if(this.mouseTool){
        this.mouseTool.close(true)
      }
    },

  }
}
</script>


<style lang="scss" scoped>
#container {
  position: relative;
  width: 100%;
  height: 100%;
}
#panel {
  position: absolute;
  background-color: white;
  max-height: 52%;
  overflow-y: auto;
  top: 128px;
  right: 10px;
  width: 280px;
}
#elevatorMap {
  height: 400px;
  margin-top: 5px;
}
::v-deep .ant-modal-body{
  padding: 0 0px;
}
</style>
<style src="../../styles/main1119.css"></style>
<style src="../../styles/demo-center.css"></style>
